module.exports = __webpack_public_path__ + "img/kanban-fill.46bb96a6.svg";